import { ColumnSelector } from '@components/columnSelector/ColumnSelector';
import { TableGridBaseColDef } from '@components/table/types/TableColumnDef.type';
import { Box } from '@mui/material';
import { useMemo } from 'react';

export type TableColumnSelectionProps = {
  columns: TableGridBaseColDef[];
  visibleColumns: Record<string, boolean>;
  onUpdateVisibleColumns: (updater: (prev: Record<string, boolean>) => Record<string, boolean>) => void;
};

export const TableColumnSelection = ({
  visibleColumns,
  columns,
  onUpdateVisibleColumns,
}: TableColumnSelectionProps) => {
  const selectableColumns = useMemo(() => Object.values(columns)?.map((col) => col.field) ?? [], [columns]);
  const columnSelector: { [key: string]: Record<string, string> } = useMemo(
    () => ({
      main: columns?.reduce(
        (acc, col) => {
          acc[col.field] = col.headerName ?? col.field;
          return acc;
        },
        {} as Record<string, string>,
      ),
    }),
    [columns],
  );

  return (
    <Box sx={{ paddingY: 1, mr: 2 }}>
      <ColumnSelector
        columnVisibility={{ ['main']: visibleColumns }}
        columnSelector={columnSelector}
        type={'main'}
        defaultDisabledKey={'codeName'}
        selectableColumns={selectableColumns}
        updateLastColumnsChecked={() => {
          // required but not needed
        }}
        updateColumnVisibility={(k) => {
          onUpdateVisibleColumns((prev) => ({
            ...prev,
            [k]: !prev[k],
          }));
        }}
        visibleColumnCount={Object.values(visibleColumns)?.length ?? 0}
      />
    </Box>
  );
};
